import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 47 52"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-width": "2",
      transform: "translate(1 1)"
    }, [
      _createElementVNode("path", {
        "stroke-linecap": "round",
        d: "M15 27.5h20a8.434 8.434 0 0 1 8.376 7.449L45 48.75M15 27.5A18.65 18.65 0 0 1 .955 13.82L0 10m15 17.5V40c0 4.714 0 7.071 1.464 8.536C17.93 50 20.286 50 25 50s7.071 0 8.536-1.464C35 47.07 35 44.713 35 40v-2.5"
      }),
      _createElementVNode("circle", {
        cx: "25",
        cy: "10",
        r: "10"
      })
    ], -1)
  ]))]))
}
export default { render: render }